export const RETRIEVE_SERVICE_AREA_BY_ZIP_SUCCESS =
    "RETRIEVE_SERVICE_AREA_BY_ZIP_SUCCESS",
  RETRIEVE_SERVICE_AREA_BY_ZIP_FAIL = "RETRIEVE_SERVICE_AREA_BY_ZIP_FAIL",
  SEARCH_BRANCHES_SUCCESS = "SEARCH_BRANCHES_SUCCESS",
  SEARCH_BRANCHES_FAIL = "SEARCH_BRANCHES_FAIL";
